<div class="tabs" id="tabs-1" style="background: white;">
        


  <div class="form-row">
    <label style="font-weight: bold; font-size: x-large;text-align: center;">Home Care Aide Exam <br>
        (Examen de asistente de atención domiciliaria)</label>
  
  </div><br><br>
  
  
     
  <form id="homecareaidexamform" [formGroup]="regForm"   (ngSubmit)="step15Submitted(regForm)" >
    
    
    <div class="container-fluid anyClass">
        

    <div class="row">
            <div class="col-sm-12  col-md-12 col-lg-12 ">


    <div class="form-group">

        <div class="questionContainer radius">
            <div class="question">
                <b>Question 1: </b>You should add a generous amount of bleach when cleaning colored clothing. 
                                   &#40;Debe añadir bastante cloro para lavar la ropa de color.&#41;

            </div>
            <div class="answers"> 
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question1"  value="1" required/>True &#47; Verdadero</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question1"  value="2" required/>False &#47; Falso</label>
                    </li>
                </ul>
            </div>       

        </div>



        <div class="questionContainer">
            <div class="question">
                <b>Question 2: </b>Dusting may be required daily when a client or family member has an allergy.
                                  &#40;Sacudir el polvo diariamente es necesario cuando hay clientes o familiares que tienen alergia.&#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question2"  value="1" required/>True &#47; Verdadero</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question2"      value="2" required/>False &#47; Falso</label>
                    </li>
                </ul>
            </div>   
        </div>

        <div class="questionContainer">
            <div class="question">
                <b>Question 3: </b>You should rearrange the client’s room as you think it would be best for the client. 
                                  &#40;Usted debe de acomodar la habitación del cliente a como usted crea que  sea conveniente para al cliente.&#41;

            </div>

            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question3"  value="1" required/>True &#47; Verdadero</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question3"  value="2" required/>False &#47; Falso</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="questionContainer">
            <div class="question">
                <b>Question 4: </b>You should keep the clients home free from dirt and soiled articles in order to prevent: 
                                  &#40;Usted debe de mantener el hogar del cliente libre de tierra y artículos sucios para prevenir: &#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question4"  value="1" required/>The spread of germs &#40;Que los gérmenes se propaguen&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question4"  value="2" required/>The transfer of infection from the client to another person. &#40;Que se transfieran los gérmenes del cliente a otra persona&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question4"  value="3" required/>Offensive Odors &#40;Olores ofensivos&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question4"  value="4" required/>All of the above &#40;Todo lo anterior&#41;</label>
                    </li>
                </ul>
            </div>
        </div>



        <div class="questionContainer">
            <div class="question">
                <b>Question 5: </b>Which of the following is the best way to gather the client’s linens and clothing for washing. 
                                  &#40;Cuales de las siguientes es la mejor manera de reunir la ropa de cama  y ropa del cliente&#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question5"  value="1" required/>Shake the linens and clothing before placing them in the hamper &#40;Sacudir la ropa de cama y toda la ropa antes de meterla en el canasto&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question5"  value="2" required/>Place dirty linens and clothing on the floor next to the hamper. &#40;Ponga las sabanas y la ropa sucia a la orilla del canasto&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question5"  value="3" required/>Leave dirty linens and clothing in the clients room until washday &#40;Dejar la ropa en el cuarto del cliente hasta el día de lavar&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question5"  value="4" required/>Hold linens and clothing away from your uniform when carrying them. &#40;Sostenga la ropa a distancia del uniforme cuando la va a trasladar&#41;</label>
                    </li>
                </ul>
            </div>
        </div>




        <div class="questionContainer">
            <div class="question">
                <b>Question 6: </b>When washing your hands, it is recommended that you rub them together with soap for at least 15 seconds and rinse them under warm, running water.
                                   &#40;Cuando se lave las manos es recomendable que las restriegue con jabón y agua tibia por lo menos 15 segundos.&#41;
            </div>

            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question6"  value="1" required/>True &#47; Verdadero</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question6"  value="2" required/>False &#47; Falso</label>
                    </li>
                </ul>
            </div>
        </div>      



        <div class="questionContainer">
            <div class="question">
                <b>Question 7: </b>Why are employee cleanliness and good personal grooming important?
                                   &#40;Porque es importante el aseo y  higiene del trabajador?&#41; 
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question7"  value="1" required/>To prevent the spread of germs &#40;Para prevenir la propagación de gérmenes&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question7"  value="2" required/>To make a good impression on the client. &#40;Para dar una buena impresión al cliente&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question7"  value="3" required/>To demonstrate a positive attitude about your work. &#40;Para demostrar una buena actitud sobre su trabajo&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question7"  value="4" required/>All of the above. &#40;(Todo lo anterior)&#41;</label>
                    </li>
                </ul>
            </div>
        </div>    

        <div class="questionContainer">
            <div class="question">
                <b>Question 8: </b>Covering the nose and mouth when coughing and sneezing will help prevent: 
                                   &#40;Cubrirse la boca y la nariz mientras uno toce y estornuda puede ayudar a prevenir: &#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question8"  value="1" required/>Offensive odors from reaching others. &#40;Que los olores ofensivos lleguen a otros&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question8"  value="2" required/>The spread of Germs &#40;La propagación de gérmenes&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question8"  value="3" required/>Clothing being soiled. &#40;Que la ropa se ensucie&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question8"  value="4" required/>Injury to the lining of the nose and mouth. &#40;Que uno se lesione el forro de la nariz y boca&#41;</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="questionContainer">
            <div class="question">
                <b>Question 9: </b>Hands are more likely to spread germs than any other part of the body. 
                                    &#40;Las manos tienen más probabilidad de propagar los gérmenes que cualquier otra parte del cuerpo&#41;.
            </div>

            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question9"  value="1" required/>True &#47; Verdadero</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question9"  value="2" required/>False &#47; Falso</label>
                    </li>
                </ul>
            </div>
        </div>   

        <div class="questionContainer">
            <div class="question">
                <b>Question 10: </b>“Unit pricing” is a wise tool to use when shopping for clients because it tells what an item’s cost is by a particular quantity. 
                                    &#40;“El precio por unidad” es un instrumento prudente de utilizar cuando hace compras para el cliente porque ayuda determinar el precio por cantidad.&#41;
            </div>

            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question10"  value="1" required/>True &#47; Verdadero</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question10"  value="2" required/>False &#47; Falso</label>
                    </li>
                </ul>
            </div>
        </div> 

        <div class="questionContainer">
            <div class="question">
                <b>Question 11: </b>Which of the following foods do not need to be stored in the refrigerator?
                                    &#40;Cuál de las siguientes comidas no tienen que mantenerse en la refrigeradora?&#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question11"  value="1" required/>Fresh meat &#40; Carne fresca&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question11"  value="2" required/>Cold cuts and hot dogs in airtight containers &#40; Embutidos y salchichas en un envase suguro&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question11"  value="3" required/>Milk &#40;Leche&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question11"  value="4" required/>Uncooked rice and noodles in airtight containers &#40; Arroz y fideos crudos en un envase seguro&#41;</label>
                    </li>
                </ul>
            </div>
        </div>


        <div class="questionContainer">
            <div class="question">
                <b>Question 12: </b>What should you do if a client discussed religious beliefs that are different from your own? 
                                    &#40; Que debe de hacer cuando el cliente habla de temas religiosos que son diferentes a los suyos?&#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question12"  value="1" required/>Listen respectfully &#40; Escuchar respetuosamente&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question12"  value="2" required/>Compare your beliefs with those of the clients &#40;Compare las creencias suyas con las del cliente&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question12"  value="3" required/>Try to change the subject &#40;Trate de cambiar el tema&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question12"  value="4" required/>None of the above &#40;Ninguna de las anteriores&#41;</label>
                    </li>
                </ul>
            </div>
        </div>

        <div class="questionContainer">
            <div class="question">
                <b>Question 13: </b>A next door neighbor is being extremely helpful by bringing food and running errands for your client. The neighbor asks you, “just how sick is Ralph?” How should you reply? 
                                    &#40; El vecino del lado esta siendo bien útil haciéndole mandados y trayéndole comida a su cliente. El vecino le pregunta, “exactamente como esta de salud Rodolfo?” Cual debe de ser su respuesta?&#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question13"  value="1" required/>“Why are you interested, it is really none of your business.” &#40;Porque esta interesado, en verdad no es su problema&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question13"  value="2" required/>“I realize your concern; however, I’m really not qualified to discuss this. You may wish to discuss it with him.” &#40;Entiendo su preocupación, pero no estoy capacitado para discutir esto. Si tiene interés, discútalo con el&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question13"  value="3" required/>“Even though you’ve been helpful, you shouldn’t ask because it not your problem and I’m not supposed to talk to anyone outside the family.” &#40; Aunque usted ha sido bien útil, no debe de preguntar esas cosas porque no es su problema y yo no puedo discutir esos asuntos con alguien fuera de la familia&#41; </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question13"  value="4" required/>None of the above &#40;Ninguna de las anteriores&#41;</label>
                    </li>
                </ul>
            </div>
        </div>


        <div class="questionContainer">
            <div class="question">
                <b>Question 14: </b>If the client will listen you may discuss your personal health problems. 
                                    &#40;Si su cliente está dispuesto a escuchar, usted debe de discutir sus problemas personales&#41;
            </div>

            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question14"  value="1" required/>True &#47; Verdadero</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question14"  value="2" required/>False &#47; Falso</label>
                    </li>
                </ul>
            </div>
        </div>  


        <div class="questionContainer">
            <div class="question">
                <b>Question 15: </b>What should you do first if cooking oil in a pan catches on fire? 
                                    &#40;Que debe de hacer primero cuando el aceite de cocinar se prenda en fuego?&#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question15"  value="1" required/>Pour water over the pan &#40;Echarle agua encima de la cazuela&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question15"  value="2" required/>Open the window &#40;Abrir la ventana&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question15"  value="3" required/>Sprinkle sugar on the pan &#40;Rociar azucar sobre la cazuela&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question15"  value="4" required/>Cover the pan &#40;Cubra la cazuela&#41;</label>
                    </li>
                </ul>
            </div>
        </div>


        <div class="questionContainer">
            <div class="question">
                <b>Question 16: </b>A pot of hot water overturns, burning your hand. What should you do immediately? 
                                    &#40;Una olla de agua se voltea quemándole la mano. Que debe de hacer inmediatamente?&#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question16"  value="1" required/>Hold the burned hand under cold running water &#40;Poner la mano quemada bajo agua fria&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question16"  value="2" required/>Massage the burned hand upwards towards the elbow. &#40;Hacerle masaje a la mano quemada hacia arriba y en dirección al codo&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question16"  value="3" required/>Apply butter or margarine to the burned hand &#40;Aplicar mantequilla o margarina a la mano quemada&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question16"  value="4" required/>Wrap the burned hand snuggly with absorbent cotton and gauge bandages &#40;Envolver la mano quemada comodamente en algodon absorbente y bendas de gaza&#41;</label>
                    </li>
                </ul>
            </div>
        </div> 

        <div class="questionContainer">
            <div class="question">
                <b>Question 17: </b>Proper body mechanics is essential to prevent back strain or injury. Which of the following is considered POOR body mechanics when lifting a heavy object? 
                                    &#40;Mecánica corporal correcta es esencial para prevenir las lesiones y dolores de espalda. Cuál de las siguientes es considerado MALA mecánica corporal cuando está levantando objetos pesados&#41; 
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question17"  value="1" required/>Keep your back straight and bend from the knees and hips &#40;Mantenga la espalda recta y doblar las rodias y caderas&#41; </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question17"  value="2" required/>Keep your feet close together and objects as far away as possible &#40;Mantenga los pies juntos y los objectos lo mas lejos posible&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question17"  value="3" required/>Roll or slide the object rather than lift &#40; Rodar o deslizar el objecto en vez de levantarlo&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question17"  value="4" required/>Hold the weight close to your body &#40; Mantenga el peso cerca del su cuerpo&#41; </label>
                    </li>
                </ul>
            </div>
        </div>


        <div class="questionContainer">
            <div class="question">
                <b>Question 18: </b>Doing a safety check of the home is the best way to prevent home accidents
                                    &#40; Hacer una inspeccion del hogar es la major manera de prevenir accidentes&#41;
            </div>

            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question18"  value="1" required/>True &#47; Verdadero</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question18"  value="2" required/>False &#47; Falso</label>
                    </li>
                </ul>
            </div>
        </div> 


        <div class="questionContainer">
            <div class="question">
                <b>Question 19: </b>Fire is the biggest safety hazards in the home &#40;El fuego es el riesgo más grande que existe en el hogar&#41;
            </div>

            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question19"  value="1" required/>True &#47; Verdadero</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question19"  value="2" required/>False &#47; Falso</label>
                    </li>
                </ul>
            </div>
        </div>  


        <div class="questionContainer">
            <div class="question">
                <b>Question 20: </b>Who should you tell if you damage something in the client’s home? 
                                    &#40;A quien le debe de avisar cuando daña algo en la casa del cliente?&#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question20"  value="1" required/>a.	Only the client &#40;Solo al cliente&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question20"  value="2" required/>b.	Only the office &#40;Solo a la oficina&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question20"  value="3" required/>c.	The client and the office &#40;Al cliente y a la oficina&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question20"  value="4" required/>d.	A neighbor or family member as to not upset the client &#40;Al vecino o miembro de la familia para así no alterar al cliente&#41;</label>
                    </li>
                </ul>
            </div>
        </div>


        <div class="questionContainer">
            <div class="question">
                <b>Question 21: </b>What should you do if a client asks you to do something for him that is not on the instructions from your supervisor 
                                    &#40;Que debe de hacer cuando el cliente le pide que haga algo que no esta en las instrucciones de su supervisor&#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question21"  value="1" required/>Do it, then call your supervisor &#40;Hagalo y despues llame a su supervisor&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question21"  value="2" required/>Tell the client that he/she has to do it him/herself &#40;Decirle al cliente que el/ella debe de hacerlo por si mismo&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question21"  value="3" required/>Call your supervisor to discuss it &#40;Llame a su supervisor para consultarlo&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question21"  value="4" required/>Ask a neighbor to do it for them &#40;Preguntele al vecino que lo haga por ellos&#41;</label>
                    </li>
                </ul>
            </div>
        </div>



        <div class="questionContainer">
            <div class="question">
                <b>Question 22: </b>What should you do if you make an error in the documentation 
                                    &#40;Que debe de hacer si hace un error en la documentación&#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question22"  value="1" required/>Erase and rewrite &#40;Borrarlo y volver a escribirlo&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question22"  value="2" required/>Draw a line through the error, initial and date the error &#40;Tacharlo con una raya, poner tus iniciales y la fecha&#41; </label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question22"  value="3" required/>Make a note of the error at the bottom of the document &#40;Haga una nota en la parte de abajo del documento&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question22"  value="4" required/>All of the above &#40;Todas las anteriores&#41;</label>
                    </li>
                </ul>
            </div>
        </div>


        <div class="questionContainer">
            <div class="question">
                <b>Question 23: </b>After working with a particular client for some time, you notice that he can no longer walk as well when you first started. What should you do? 
                                    &#40; Después de trabajar con el cliente por un tiempo, usted se da cuenta que él no puede caminar tan bien como cuando empezó con él.  Que debe de hacer? &#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question23"  value="1" required/>Rearrange the furniture so that the client can “hang on” to it while he walks. &#40;Reorganice los muebles para que el cliente se pueda “sostener de” algo mientras camina&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question23"  value="2" required/>Call your supervisor to notify him that the client’s condition has changed &#40;Llame a su supervisor y avísele que el estado del cliente ha cambiado&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question23"  value="3" required/>Suggest the client buy a cane or Walker &#40;Sugiérale al cliente que compre un bastón o andarivel&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question23"  value="4" required/>Ignore the issue. You are only there to provide non-personal care &#40;Ignore la situación. Usted no está  ahí para brindar cuidado personal&#41;</label>
                    </li>
                </ul>
            </div>
        </div>



        <div class="questionContainer">
            <div class="question">
                <b>Question 24: </b>Which of the following should you take into consideration when planning a client’s meals? 
                                    &#40;Cual de lo siguiente tiene que tener en mente mientras planea los alimentos del cliente?&#41;
            </div>
            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question24"  value="1" required/>The client’s likes and dislikes &#40;Lo que le gusta o no le gusta al cliente&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question24"  value="2" required/>The food Pyramid &#40;La pirámide de alimentos&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question24"  value="3" required/>The food Budget &#40;El presupuesto de alimentos&#41;</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question24"  value="4" required/>All of the Above &#40;Todo las anteriores&#41;</label>
                    </li>
                </ul>
            </div>
        </div>




        <div class="questionContainer">
            <div class="question">
                <b>Question 25: </b>Your client tells you that you are doing a really good job, and wants to give you a gift.  Since he told you that you are doing a good job, it is okay to accept the gift. 
                                    &#40;Su cliente le dice que está haciendo un trabajo bien bueno, y quiere darle un regalo. Ya que le dijo que usted está haciendo un buen trabajo, está bien aceptar el regalo&#41;
            </div>

            <div class="answers">
                <ul>
                    <li>
                        <label><input type="radio" formControlName="Question25"  value="1" required/>True &#47; Verdadero</label>
                    </li>
                    <li>
                        <label><input type="radio" formControlName="Question25"  value="2" required/>False &#47; Falso</label>
                    </li>
                </ul>
            </div>
        </div>   


    </div>

            </div>
    </div>

    <br/>

</div>



<button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i class="ace-icon fa fa-arrow-left"></i>Prev Page</button>
&nbsp;
<button type="submit"  class="btn btn-primary" >Save and Continue &nbsp;
  <i class="ace-icon fa fa-arrow-right icon-on-right"></i></button>   
  


  <div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> Saving Data...</i>

    </form>

  

</div>
   